import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { LoginService } from '../services/login.service';

@Injectable()
export class TokenGuard {

    constructor(private router: Router, private loginService: LoginService) {
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        console.debug('TokenGuard.canActivateChild', childRoute, state);
        if (this.loginService.accessTokenV2 && this.loginService.accessTokenV1 &&
            this.loginService.refreshTokenV2 && this.loginService.refreshTokenV1 &&
            this.loginService.lastRefreshTimeV2 && this.loginService.lastRefreshTimeV1) {
            return true;
        } else {
            this.router.navigate(['/login'], { queryParams: { redirect: state.url } });
            return false;
        }
    }
}
